export default __webpack_public_path__ + "static/media/mo-parteners-digi-connect-l.f6b12258.png";